import { render, staticRenderFns } from "./VxList.vue?vue&type=template&id=6bbbf2e6"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"
import style0 from "./VxList.vue?vue&type=style&index=0&id=6bbbf2e6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bbbf2e6')) {
      api.createRecord('6bbbf2e6', component.options)
    } else {
      api.reload('6bbbf2e6', component.options)
    }
    module.hot.accept("./VxList.vue?vue&type=template&id=6bbbf2e6", function () {
      api.rerender('6bbbf2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vx-list/VxList.vue"
export default component.exports